import type { ReadableWithCurrent } from '$lib/stores/add-current.svelte'
import type { TypedSupabaseClient } from '$lib/supabase'
import { getContext, setContext } from 'svelte'

const KEY = {}

type SupabaseContext = {
  supabase: ReadableWithCurrent<TypedSupabaseClient>
}

export const setSupabaseContext = (value: SupabaseContext) =>
  setContext(KEY, value)
export const getSupabaseContext = () => getContext<SupabaseContext>(KEY)
